<img src="../../assets/img/{{themeService.theme}}/how-works.svg" alt="Section Logo" width="170px">
<div class="title">What is a delegate?</div>
<p>
    Congratulations on being made a delegate! This means someone close to you has chosen to share
    their plan with you.
</p>
<p>
    In case you are not familiar with <span *ngIf="isDefaultTheme != false">Zenplans</span><span *ngIf="isDefaultTheme == false">{{text}}</span>, we're here to help people live comfortably knowing
    that their life’s important information is all kept in one secure place, there for them to use
    in life and there for their loved ones to access if they pass away or lose capacity.
</p>
<p>
    As a delegate, you can access a plan according to the permission level that you have been granted
    by the plan owner. Head over to your Shared Plans menu to see the plans that have been shared
    with you.
</p>